/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents, ContactTermsPayables } from '@gh/builder-shared-data';
import { ActionFlow, EnumDictionary, getRouteInitData, IS_REGION_NZ } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { DialogService, yesAnswer, yesNoConfirmation } from '@gh/core-ui';
import { filter$ } from '@gh/rx/operators';
import { SystemVarsPayables } from '../../resources/model/system-vars-payables.model';
import { SystemVarsPayablesTabBusinessService } from '../../resources/system-vars-payables-tab-business.service';

import { SystemVarsPayablesTabFormState } from './system-vars-payables-tab-form.service';

@Component({
  standalone: false,
  selector: 'gh-system-vars-payables-tab',
  templateUrl: 'system-vars-payables-tab.component.html',
  providers: [
    SystemVarsPayablesTabFormState,
  ],
})
export class SystemVarsPayablesTabComponent extends AbstractFormComponent<SystemVarsPayables>
  implements OnInit {

  termsPayables: EnumDictionary<ContactTermsPayables>;
  isRegionNz = IS_REGION_NZ;

  private payablesSystemVariables: SystemVarsPayables;

  constructor(public form: SystemVarsPayablesTabFormState,
              private route: ActivatedRoute,
              private translationService: TranslationService,
              private systemVarsBusiness: SystemVarsPayablesTabBusinessService,
              private navigationService: BuilderNavigationService,
              private dialogService: DialogService,
              private userContext: BuilderUserContext,
              private pipelines: FormActionPipelines,
              private actions: CommonActions) {
    super();
  }

  get payDefaultPaymentBalanceDaysPlaceholder(): string {
    switch (this.form.get('payDefaultPaymentDue').value) {
      case ContactTermsPayables.OnMonthDay:
      case ContactTermsPayables.MonthDayAfterEOM:
        return 'lbl_terms_due_day';
      default:
        return 'lbl_terms_balance_due';
    }
  }

  onPayDefaultPaymentDueChange(paymentDue: ContactTermsPayables): void {
    this.form.disableOrEnableControlsByPaymentDue(paymentDue);
  }

  ngOnInit(): void {
    const { payablesSystemVariables, termsPayables } = getRouteInitData(this.route);
    this.payablesSystemVariables = payablesSystemVariables;
    this.termsPayables = termsPayables;
    this.form.build(payablesSystemVariables);
  }

  get completeFlow(): ActionFlow<FormFlowState<SystemVarsPayables>> {
    return this.pipelines.complete({
      execute: this.actions.execute(({ value }: FormFlowState<SystemVarsPayables>) =>
        this.systemVarsBusiness.update(value)),
      finish: ({ value }: FormFlowState<SystemVarsPayables>) => {
        this.payablesSystemVariables = value;
        this.form.build(value);
      },
    });
  }

  onReset(): void {
    this.dialogService
      .confirmation(yesNoConfirmation('msg_reset')).pipe(
      filter$(yesAnswer))
      .subscribe(() => this.form.build(this.payablesSystemVariables));
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.userContext.office && this.userContext.office.id,
      entityType: 'OFFICE',
      eventTypeIds: [AelEvents.Office.EditedPayables],
      label: 'lbl_payables',
    });

  }
}
